module.exports = __webpack_public_path__ + "media/משחקים.6db573a4.mp3";